// 放置所有的请求接口地址

//const url = 'http://zhongheneng.51guanzhu.com'
//const url = 'http://zhongheneng.net'

// ✅ 1. 判断当前环境：开发(本地/测试) vs 生产(线上)
const isDev = process.env.NODE_ENV === 'development'||window.location.hostname === 'localhost'||window.location.hostname.includes('51guanzhu')

// ✅ 2. 根据环境选择域名
const domain = isDev ? 'zhongheneng.51guanzhu.com' : 'zhongheneng.net'

// ✅ 3. 自动跟随当前页面协议（http 或 https）
const url = `${window.location.protocol}//${domain}`

//url = 'http://zhongheneng.net';
const urls = class{
	static m(){
		const baseurl = `${url}`
		const imgUrl = ``
		// 导航栏目信息（topNav footNav） get
		const navInfos = `${url}/api/ClassInfos`
		//首页swiper /post
		const homeSwiper=`${url}/api/Banners`
		//获取单页详情about /get
		const singleInfos =`${url}/api/SingleInfos/`//${url}/api/SingleInfos/${classId} 
		//关于我们 荣誉资质 合作伙伴图片 post
		const classPics =`${url}/api/ClassPics/`//api/ClassPics/${classId}?limit=${limit} 
		//页面中的tab切换页签 （产品中心，新闻中心，服务支持） get 
		const pageTabs =`${url}/api/ClassInfos/`// /api/ClassInfos/${fatherId}
		//下载资料 post
		const downloads =`${url}/api/Downloads/`// /api/Downloads/${classId}
		//记录下载次数  post
		const downloadCount =`${url}/api/Downloads/`// /api/Downloads/${id}/click
		//添加留言 post /api/Feedbacks
		const addMessage =`${url}/api/Feedbacks`// /api/Downloads/${id}/click
		//留言板校验验证码  post  
		const verifyCode =`${url}/api/verify/verify`// /api/verify/verify 
		//企业新闻，行业动态列表数据 post 
		const newsListInfos =`${url}/api/NewsListInfos/`// /api/NewsListInfos/${classId}
		//新闻文章信息 get /api/NewsListInfos/${id}
		const newsDetailInfos =`${url}/api/NewsListInfos/`// /api/NewsListInfos/${id}
		//产品中心，产品列表 post 
		const productListInfos =`${url}/api/ProductListInfos/` ///api/ProductListInfos/${classId}/${productClassId}
		//从首页产品分类进入产品列表页面 post /api/ProductLists/${classId}/${productFatherClassId}
		const productListFromHome = `${url}/api/ProductLists/` ///api/ProductLists/${classId}/${productFatherClassId}
		//获取产品详情 get  /api/ProductListInfos/{id}
		const ProductDetail =`${url}/api/ProductListInfos/`// /api/ProductListInfos/{id}
		//获取产品分类 （产品中心->产品列表左侧菜单） get 
		const productClass =`${url}/api/ProductClass`// /api/ProductClass
		//首页产品数据 post 
		const homeProductList =`${url}/api/index/ProductListInfos/`// /api/index/ProductListInfos/${classId}?limit=${limit}
		//首页产品分类数据 get HomeProductClass   
		const homeProductClass =`${url}/api/index/ProductClass`// /api/index/ProductClass?limit=4
		//首页新闻列表 get data 
		const homeNewsList = `${url}/api/index/NewsListInfos` // /api/index/NewsListInfos
		//获取网站信息 get(包含网站logo,电话，地址，名称，网站TDK,微信二维码) 存到stroe.state
		const websiteInfos =`${url}/api/sysconfig`// /api/sysconfig
		//搜索结果 post /api/index/SearchListInfos/{keyword}
		const getSearchList = `${url}/api/index/SearchListInfos/`// /api/index/SearchListInfos/{keyword}


//获取短信验证码 post {"mobile": "string", "type": "string"} 验证码类型 :1-PC注册，2-PC登录，3-PC找回密码
const sendSmsCode =`${url}/api/v1/sendSmsVerification`  //  /api/v1/sendSmsVerification
//注册 post {"mobile": "13426128425","code": "123456","password": "Aalllsl"}
const register =`${url}/api/v1/register`  //  /api/v1/register
//登录 post /api/v1/login
const login =`${url}/api/v1/login`  //  /api/v1/login
//根据手机号获取用户信息 get 
const userInfo =`${url}/api/user/v1/userInfo/`  //  /api/user/v1/userInfo/{mobile}
//根据手机号验证是否为注册过的会员 get /v1/user/{mobile}
const userByMobile =`${url}/api/v1/user/`  //  /v1/user/{mobile}
//验证校验码，获取找回密码适用的临时token resetToken post /api/v1/checkSmsVerification
const checkSmsVerification =`${url}/api/v1/checkSmsVerification` ///api/v1/checkSmsVerification
//重置密码 post /api/v1/resetPassword
const resetPassword =`${url}/api/v1/resetPassword` ///api/v1/resetPassword
//获取购物车商品数量用于topNav中 get /api/cart/v1/cartCount
const getCartCount =`${url}/api/cart/v1/cartCount` ///api/cart/v1/cartCount
//加入购物车 post /api/cart/v1/cart
const addCart = `${url}/api/cart/v1/cart` ///api/cart/v1/cart
//购物车列表 get /api/cart/v1/cartList
const getcartList =`${url}/api/cart/v1/cartList` ///api/cart/v1/cartCount
//删除单个商品 del /api/cart/v1/cart
const delCart = `${url}/api/cart/v1/cart` ///api/cart/v1/cart
//获取购物车过期时间 get /api/cart/v1/expiration
const getCartExpiration = `${url}/api/cart/v1/expiration` ///api/cart/v1/expiration
//获取失效产品列表 get /api/cart/v1/cartListInvalid(批量删除商品也用这个接口，方式为delete)
const getCartListInvalid = `${url}/api/cart/v1/cartListInvalid` ///api/cart/v1/cartListInvalid
//获取用户地址列表 get /api/user/v1/address
const getAddressList = `${url}/api/user/v1/address` ///api/user/v1/address
//获取地址的树形结构 get /api/user/v1/addressTree
const getAddressTree = `${url}/api/user/v1/addressTree` ///api/user/v1/addressTree
//添加用户收货地址 post /api/user/v1/address
const addAddress = `${url}/api/user/v1/address` ///api/user/v1/address
//预提交定单，购物车页面点结算 post /api/order/v1/preOrder
const preOrder = `${url}/api/order/v1/preOrder` ///api/order/v1/preOrder
//根据省份获取运费 get /api/order/v1/shippingFee
const getShippingFee = `${url}/api/order/v1/shippingFee` ///api/order/v1/shippingFee
//提交订单 post /api/order/v1/Order
const submitOrder = `${url}/api/order/v1/Order` ///api/order/v1/Order
//查询订单详情 get /api/order/v1/orderDetail
const getOrderDetail = `${url}/api/order/v1/orderDetail` ///api/order/v1/orderDetail
//查询所有订单 post /api/order/v1/orderList (订单状态:-1已作废（取消订单）,0超时未支付,1等待支付,2已支付,3已发货,4确认收货)
const getOrderList = `${url}/api/order/v1/orderList` ///api/order/v1/orderDetail
//立即支付 post /api/payment/alipay/pay
const payAli = `${url}/api/payment/alipay/pay` ///api/payment/alipay/pay
//再次购买的加入购物车功能 post /api/order/v1/addCartAgain
const addCartAgain = `${url}/api/order/v1/addCartAgain` ///api/order/v1/addCartAgain
//修改密码 post /api/user/v1/changePassword
const changePassword = `${url}/api/user/v1/changePassword` ///api/user/v1/changePassword
//删除订单 delete /api/order/v1/Order 同 submitOrder 只是请求方式不同
//获取订单数量，用在我的商城中 get /api/order/v1/statusCount
const getStatusCount = `${url}/api/order/v1/statusCount` ///api/order/v1/statusCount
//取消订单 put /api/order/v1/cancelOrder
const cancelOrder = `${url}/api/order/v1/cancelOrder` ///api/order/v1/cancelOrder
//申请退款 post /api/refundOrder//v1/refundOrde
const refundOrder = `${url}/api/refundOrder/v1/refundOrder` ///api/refundOrder/v1/refundOrder
//查询售后列表 post /api/refundOrder/v1/refundOrderList
const getRefundOrderList = `${url}/api/refundOrder/v1/refundOrderList` ///api/refundOrder/v1/refundOrderList
//修改用户信息 put /api/user/v1/userInfo
const editUserInfo = `${url}/api/user/v1/userInfo` ///api/user/v1/userInfo
//查看退单详情 get /api/refundOrder/v1/refundOrderDetail
const getRefundOrderDetail = `${url}/api/refundOrder/v1/refundOrderDetail` ///api/refundOrder/v1/refundOrderDetail
//确认收货  put /api/order/v1/confirmReceipt
const confirmReceipt = `${url}/api/order/v1/confirmReceipt` ///api/order/v1/confirmReceipt
//上传图片  post /api/refundOrder/upload/image/{type}
const uploadImg = `${url}/api/refundOrder/upload/image/` ///api/refundOrder/upload/image/{type}
//获取物流公司 get /api/shippingCompanys
const getShippingCompanys = `${url}/api/shippingCompanys` ///api/shippingCompanys
//提交物流信息 post /api/refundOrder/v1/refundOrderLogistics
const refundOrderLogistics = `${url}/api/refundOrder/v1/refundOrderLogistics` ///api/refundOrder/v1/refundOrderLogistics
//取消售后 put /api/refundOrder/v1/cancelRefundOrder
const cancelRefundOrder = `${url}/api/refundOrder/v1/cancelRefundOrder` ///api/refundOrder/v1/cancelRefundOrder
//检查token get /api/checkToken
const checkToken=`${url}/api/checkToken` ///api/checkToken
return{
			baseurl,
			imgUrl,
			navInfos,
			homeSwiper,
			singleInfos,
			classPics,
			pageTabs,
			downloads,
			downloadCount,
			addMessage,
			verifyCode,
			newsListInfos,
			newsDetailInfos,
			productListInfos,
			productListFromHome,
			ProductDetail,
			productClass,
			homeProductList,
			homeProductClass,
			homeNewsList,
			websiteInfos,
			getSearchList,
			sendSmsCode,
			register,
			login,
			userInfo,
			userByMobile,
			checkSmsVerification,
			resetPassword,
			getCartCount,
			addCart,
			getcartList,
			delCart,
			getCartExpiration,
			getCartListInvalid,
			getAddressList,
			getAddressTree,
			addAddress,
			preOrder,
			getShippingFee,
			submitOrder,
			getOrderDetail,
			getOrderList,
			payAli,
			addCartAgain,
			changePassword,
			getStatusCount,
			cancelOrder,
			refundOrder,
			getRefundOrderList,
			editUserInfo,
			getRefundOrderDetail,
			confirmReceipt,
			uploadImg,
			getShippingCompanys,
			refundOrderLogistics,
			cancelRefundOrder,
			checkToken
		}
	}
}

export default urls